function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var intellcontReadOnly = {
  uiSchema: {
    'ui:disabled': true
  },
  collapseDateGroups: true,
  collapseAuthors: true,
  order: ['details', 'authors', 'other'],
  titles: {
    author: 'Author',
    authors: 'Author & Editor Details',
    details: 'Contribution Details',
    name: 'Name',
    other: 'Additional Details'
  }
};
var intellcontEditable = _objectSpread({}, intellcontReadOnly, {
  collapseDateGroups: false,
  collapseAuthors: false,
  uiSchema: {}
});
export default {
  intellcont: {
    readOnly: intellcontReadOnly,
    editable: intellcontEditable
  }
};